module.exports = __webpack_public_path__ + "static/media/insights-logo.e7599e8b.svg";